import { render, staticRenderFns } from "./SellBusienes.vue?vue&type=template&id=0804ed2e&scoped=true&"
import script from "./SellBusienes.vue?vue&type=script&lang=js&"
export * from "./SellBusienes.vue?vue&type=script&lang=js&"
import style0 from "./SellBusienes.vue?vue&type=style&index=0&id=0804ed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804ed2e",
  null
  
)

export default component.exports